export default __webpack_public_path__ + "static/media/cwsuiteWhite.b9a2392a.svg";